import { isAndroid, isIOS, isMobile } from 'react-device-detect';
import appStoreDownloadImg from '../../../assets/appStoreDownloadBlack.svg';
import googlePlayDownloadImg from '../../../assets/googlePlayDownloadBlack.svg';
import { useAnalytics } from '../../../utils/analytics';
import { goToDeepLink } from '../../../utils/utilsFunctions';
import {
  DownloadBox,
  DownloadBoxButton,
  DownloadBoxButtonImg,
  DownloadBoxButtonsWrapper,
  DownloadBoxText,
} from './GoToAppDownloadBox.style';
import { GoToAppStepProps } from './GoToAppStep.types';

type GoToAppDownloadBoxProps = Pick<
  GoToAppStepProps,
  | 'includePaymentConfirmationActions'
  | 'mobileLink'
  | 'isAppsflyer'
  | 'androidPlayStoreUrl'
  | 'iosAppStoreUrl'
  | 'desktopLink'
>;

export const GoToAppDownloadBox: React.FC<GoToAppDownloadBoxProps> = ({
  desktopLink,
  mobileLink,
  includePaymentConfirmationActions,
  androidPlayStoreUrl,
  iosAppStoreUrl,
  isAppsflyer = false,
}) => {
  const analytics = useAnalytics();

  const handleIOSdeeplinkClick = () => {
    handleDeeplink('ios');
  };

  const handleAndroidDeeplinkClick = () => {
    handleDeeplink('android');
  };

  const handleDeeplink = (deviceType: 'ios' | 'android') => {
    analytics.track('app store redirect click', {
      appStoreVersion: deviceType,
      ctaLocation: includePaymentConfirmationActions ? 'paymentConfirmationPage' : 'goToApp',
    });

    const iosDesktopLink = iosAppStoreUrl ?? desktopLink;
    const androidDesktopLink = androidPlayStoreUrl ?? desktopLink;

    const properDesktopLink = deviceType === 'ios' ? iosDesktopLink : androidDesktopLink;

    goToDeepLink({ mobileLink, desktopLink: properDesktopLink, isAppsflyer });
  };

  return (
    <DownloadBox>
      <DownloadBoxText>
        <b>Download the app</b> and log in with your phone number to join your first group.
      </DownloadBoxText>
      <DownloadBoxButtonsWrapper>
        {(!isMobile || isAndroid) && (
          <DownloadBoxButton onClick={handleAndroidDeeplinkClick}>
            <DownloadBoxButtonImg src={googlePlayDownloadImg} alt="Get it on Google Play" />
          </DownloadBoxButton>
        )}
        {(!isMobile || isIOS) && (
          <DownloadBoxButton onClick={handleIOSdeeplinkClick}>
            <DownloadBoxButtonImg src={appStoreDownloadImg} alt="Download on the App Store" />
          </DownloadBoxButton>
        )}
      </DownloadBoxButtonsWrapper>
    </DownloadBox>
  );
};
